<template>
  <div class="estranged salebench_com">
    <el-table id="table" class="table" ref="multipleTable" :data="unContactData" v-loading = "isLoading" element-loading-background = "rgba(0, 0, 0, 0.3)" element-loading-text = "数据正在加载中" element-loading-spinner = "el-icon-loading" @sort-change='sortThisColumn' border stripe highlight-current-row  size="mini" style="width: 100%;" height="100%">
      <el-table-column type="index" align="center" width="40" v-if="customerColumn.indexOf(',name,')!=-1"></el-table-column>
      <el-table-column prop="customer" v-if="customerColumn.indexOf(',name,')!=-1" label="客户名称" show-overflow-tooltip width="180">
        <template v-slot="scope">
          <span class="link" @click="linkToInfo(scope.row.id, scope.row.name)">{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="linkman" v-if="customerColumn.indexOf(',linkman,')!=-1" label="联系人" width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="phone" v-if="customerColumn.indexOf(',phone,')!=-1" label="联系电话" width="120"></el-table-column>
      <el-table-column prop="salesman_name" label="归属人" width="100" v-if="customerColumn.indexOf(',salesman_name,')!=-1"></el-table-column>
      <el-table-column prop="customer_attribute_name" v-if="customerColumn.indexOf(',customer_attribute_name,')!=-1" label="客户属性" width="120"></el-table-column>
      <el-table-column prop="customer_source_name" v-if="customerColumn.indexOf(',customer_source_name,')!=-1" label="客户来源" width="120"></el-table-column>
      <el-table-column prop="lx_type" label="未联系天数" width="110" show-overflow-tooltip v-if="customerColumn.indexOf(',lx_type,')!=-1">
        <template v-slot="scope">
          <span>{{scope.row.lx_type.msg == '' ? '' : scope.row.lx_type.days + '天未联系'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contact_times" label="联系次数" width="100" sortable='custom' v-if="customerColumn.indexOf(',contact_times,')!=-1"></el-table-column>
      <el-table-column prop="sell_amount" v-if="customerColumn.indexOf(',sell_count,')!=-1" label="历史成交(次数)" width="160" show-overflow-tooltip sortable='custom'>
        <template v-slot="scope">
          <span>{{scope.row.sell_square_sum == null ? 0 : scope.row.sell_square_sum}} m³ ({{scope.row.sell_count}}次)</span>
        </template>
      </el-table-column>
      <el-table-column prop="visit_times" v-if="customerColumn.indexOf(',visit_times,')!=-1" label="回访次数" width="120" sortable='custom'></el-table-column>
        <el-table-column prop="visit_time" v-if="customerColumn.indexOf(',visit_time,')!=-1" label="上次回访日期" width="120" show-overflow-tooltip sortable='custom'></el-table-column>
      <el-table-column prop="visit_content" v-if="customerColumn.indexOf(',visit_content,')!=-1" label="上次回访内容" width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="deal_time" v-if="customerColumn.indexOf(',deal_time,')!=-1" label="上次交易时间" width="150" show-overflow-tooltip sortable='custom'></el-table-column>  
      <el-table-column prop="main_business" v-if="customerColumn.indexOf(',main_business,')!=-1" label="主营项目" width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="breed" v-if="customerColumn.indexOf(',breed,')!=-1" label="采购品类" show-overflow-tooltip width="120"></el-table-column>
      <el-table-column prop="remark" v-if="customerColumn.indexOf(',remark,')!=-1" label="备注" show-overflow-tooltip min-width="200"></el-table-column>
    </el-table>
    <div class="pag">
      <pagination v-if="refresh" ref="pagination" :lastpages.sync="pages.last_page" :currentpages.sync="pages.current_page" :all.sync="pages.total" :pagesizes.sync="pages.per_page" @getPage="getPage"></pagination>
    </div>
  </div>
</template>

<script>
import pagination from '../../../../components/pagination' 
export default {
  components: {
    pagination
  },
  props: {
    unContactData: {
      type: Array,
      default(){
        return []
      }
    },
    pages: {
      type: Object,
      default: function(){
        return {
          last_page: 1,
          total: 0,
          current_page: 1,
          per_page: 20
        }
      }
    },
    customerColumn: {
      type: String,
      default: function(){
        return ''
      }
    },
    isLoading:{
      type:Boolean
    }
  },
  data(){   
    return {     
      last_page: 1,
      current_page: 1,
      total: 100,
      page: 1,
      per_page: 10,
      refresh: true
    }
  },
  methods: {
    //排序
    sortThisColumn(column){
      if(column.prop == "contact_times" && column.order == "ascending"){
        this.$emit('sortEstrangedCustomer',{order: "asc", column: "contact_times"})
      }else if(column.prop == "contact_times" && column.order == "descending"){
        this.$emit('sortEstrangedCustomer',{order: "desc", column: "contact_times"})
      }else if(column.prop == "visit_times" && column.order == "ascending"){  
        this.$emit('sortEstrangedCustomer',{order: "asc", column: "visit_times"})
      }else if(column.prop == "visit_times" && column.order == "descending"){
        this.$emit('sortEstrangedCustomer',{order: "desc", column: "visit_times"})
      }else if(column.prop == "visit_time" && column.order == "ascending"){
        this.$emit('sortEstrangedCustomer',{order: "asc", column: "visit_time"})
      }else if(column.prop == "visit_time" && column.order == "descending"){
        this.$emit('sortEstrangedCustomer',{order: "desc", column: "visit_time"})
      }else if(column.prop == "deal_time" && column.order == "ascending"){        
        this.$emit('sortEstrangedCustomer',{order: "asc", column: "deal_time"})
      }else if(column.prop == "deal_time" && column.order == "descending"){
        this.$emit('sortEstrangedCustomer',{order: "desc", column: "deal_time"})
      }else if(column.prop == "sell_amount" && column.order == "ascending"){
        this.$emit('sortEstrangedCustomer',{order: "asc", column: "sell_square_sum"})
      }else if(column.prop == "sell_amount" && column.order == "descending"){
        this.$emit('sortEstrangedCustomer',{order: "desc", column: "sell_square_sum"})
      }else{
        this.$emit('sortEstrangedCustomer',{order: "", column: ""})
        return
      }
    },
    //点击客户名称
    linkTo(){
      if(this.multipleSelection.length == 0) return;
      this.dialogFormVisible = true
    },
    //分页
    getPage(obj){
      this.$emit('pageChangeEvent', obj)
    },
    //跳转至客户
    linkToInfo(id, name){
      localStorage.setItem("dw_erp_customer_id",id);
      localStorage.setItem("dw_erp_customer_name_workbench", name)
      this.$emit("grandEstranged")
    }
  },
  watch: {
    selectData(data){
      this.selectRow = [];
      if(data.length>0){
        data.forEach(item=>{
          this.selectRow.push(item.id);
        })
      }
    },
    pages(){
      //强制刷新组件
      this.refresh= false
      this.$nextTick(()=>{
        this.refresh = true
      })
    }   
  }
}
</script>

<style lang="scss" scoped>
.estranged{
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: left;
  .table{
    flex: 1;
    margin-top: 5px;
    .link{
      color: #0099ff;
      cursor: pointer;
    }
    .link:hover{
      text-decoration: underline;
    }
    .hei{
        display: inline-block;
        width: 16px;
        height: 16px;
        line-height: 16px;
        border-radius: 50%;
        background: #333;
        color: #fff;
        font-size: 10px;
        text-align: center;
        margin-left: 3px;
    }
  }
  .pag{
    text-align: center;
    margin-bottom: 10px;
  }
}

.estranged /deep/ .el-table th.gutter {display: table-cell !important;}
.estranged /deep/ .el-table th.gutter{display: block !important;width: 28px !important;}
.estranged /deep/ .el-tablecolgroup.gutter{display: block !important;width: 28px !important;}
.estranged /deep/ .el-table--border, .estranged /deep/ .el-table--group {border: 1px solid #fff;}
.estranged /deep/ .el-table--border th.gutter:last-of-type {border-bottom-color: #fff;border-top: 1px solid #ddd;position: relative;top: -1px;}
</style>